import * as React from 'react';

import * as style from './SearchResultItemCell.css';

export interface ISearchResultItemCellProps {
  href?: string;
  title?: string;
  children: React.ReactNode;
}
export const SearchResultItemCell: React.FC<ISearchResultItemCellProps> = props => {
  const { href, title, children } = props;

  return (
    <td className={style['cell']}>
      {href && title ? (
        <a href={href} title={title} className={style['cell-content']}>
          {children}
        </a>
      ) : (
        <div className={style['cell-content']}>{children}</div>
      )}
    </td>
  );
};
